import { Col, Modal } from 'components';
import { useTranslation } from 'react-i18next';

import { UserItem } from './';

const AthletesModal = ({ visible, closeModal, data, pricing, handleExclude }) => {
  const { t } = useTranslation();

  return (
    <Modal visible={visible} closeModal={closeModal}>
      <Col bg="#fff" wid="calc(100% - 32px)" pad="32px 16px 0" maxHt="500px" noFlex>
        {data.map((item) => (
          <UserItem
            user={{
              ...item,
              bio:
                item.sports.length > 0 && item.sports[0].position
                  ? t(`${item.sports[0].sport}.${item.sports[0].position}`)
                  : ''
            }}
            handleSelect={() => handleExclude(item._id, pricing.user._id)}
            pricing={!pricing.excludeIds?.find((x) => x === item._id)}
          />
        ))}
      </Col>
    </Modal>
  );
};

export default AthletesModal;
